import { keyframes } from "@emotion/react";

const loadingAnimation = keyframes`
  0% { content: ''; }
  25% { content: '.'; }
  50% { content: '..'; }
  75% { content: '...'; }
  100% { content: ''; }
`;

const LoadingComponent = ({ error, message }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
    }}
  >
    <div
      style={{
        fontSize: "2rem",
        fontWeight: 600,
        color: "#344767",
      }}
    >
      {error ? "Falha ao carregar" : "Carregando"}
      <span
        style={{
          display: "inline-block",
          minWidth: "1.5em",
        }}
        css={{
          "&::after": {
            content: "''",
            animation: `${loadingAnimation} 1.5s infinite`,
          },
        }}
      />
    </div>
    <p
        style={{
          margin: "0px",
          fontSize: "1rem",
          color: "#67748e",
          textAlign: "center",
        }}
      >
        {message}
      </p>
  </div>
);

export default LoadingComponent;